import {reset} from 'redux-form'
import {getCurrentSitePlease} from 'redux/modules/currentUser/actions'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'
import {CALL_API, Call} from 'redux/middleware/api'
import {batchActions} from 'redux-batch-enhancer'
import {reportError} from 'redux/modules/error/actions'
import formatDateWithTz from 'utils/formatDateWithTz'
import {getUnmappeImpressions} from './selectors'
import json2csv from 'json2csv'

import {
  CATEGORY_MAPPINGS,
  ADD_CATEGORY_MAPPING,
  REMOVE_CATEGORY_MAPPING,
  CHANNEL_MAPPINGS,
  URL_MAPPINGS,
  UNMAPPED_URLS,
  REFERRER_MAPPINGS,
  UNMAPPED_REFERRERS,
  MAP_UNMAPPED_REFERRER,
  DELETE_MAPPED_REFERRER,
  UTM_MAPPINGS,
  UNMAPPED_UTMS,
  MAP_UNMAPPED_UTM,
  DELETE_MAPPED_UTM,
  MAP_UNMAPPED_URL,
  DELETE_MAPPED_URL,
  UNMAPPED_IMPRESSIONS
} from './index'

function loadMappingsForCategory({merchantSiteId, category}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/categoryMappings`,
      errorsHandled: true,
      types: CATEGORY_MAPPINGS,
      queryParams: {category}
    }
  }
}

function loadMappingsForChannel({merchantSiteId, channelGroupId, channelId}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/mappings`,
      errorsHandled: true,
      types: CHANNEL_MAPPINGS,
      queryParams: {
        dv_chgroup: channelGroupId,
        dv_channel: channelId
      }
    }
  }
}

function loadUnmappedUrls({merchantSiteId}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/mappableUrls`,
      errorsHandled: true,
      types: UNMAPPED_URLS
    }
  }
}

function loadUrlMappings({merchantSiteId}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/urlMappings`,
      errorsHandled: true,
      types: URL_MAPPINGS
    }
  }
}

function loadUnmappedReferrers({merchantSiteId}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/mappableReferrers`,
      errorsHandled: true,
      types: UNMAPPED_REFERRERS
    }
  }
}

function loadReferrerMappings({merchantSiteId}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/referrerMappings`,
      errorsHandled: true,
      types: REFERRER_MAPPINGS
    }
  }
}

function loadUnmappedUtms({merchantSiteId}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/mappableUTMs`,
      errorsHandled: true,
      types: UNMAPPED_UTMS
    }
  }
}

function loadUtmMappings({merchantSiteId}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/utmMappings`,
      errorsHandled: true,
      types: UTM_MAPPINGS
    }
  }
}

function loadUnmappedImpressions({merchantSiteId, startDate, endDate, timezone}) {
  return {
    [CALL_API]: {
      endpoint: `sites/${merchantSiteId}/mappableImpressions`,
      errorsHandled: true,
      types: UNMAPPED_IMPRESSIONS,
      queryParams: {
        merchantSiteId,
        range: {
          start: startDate,
          end: endDate
        },
        timezone
      }
    }
  }
}

export function fetchMappingsForCategory(category) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {merchantSiteId, category}
      dispatch(loadMappingsForCategory(fetchParams)).fail(
        dispatch(reportError())
      )
    })
  }
}

export function fetchMappingsForChannel(channelGroupId, channelId) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {merchantSiteId, channelGroupId, channelId}
      dispatch(loadMappingsForChannel(fetchParams)).fail(
        dispatch(reportError())
      )
    })
  }
}

export function fetchUnmappedUrls() {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {merchantSiteId}
      dispatch(loadUnmappedUrls(fetchParams)).fail(dispatch(reportError()))
    })
  }
}

export function fetchUrlMappings() {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {merchantSiteId}
      dispatch(loadUrlMappings(fetchParams)).fail(dispatch(reportError()))
    })
  }
}

export function fetchUnmappedReferrers() {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {merchantSiteId}
      dispatch(loadUnmappedReferrers(fetchParams)).fail(dispatch(reportError()))
    })
  }
}

export function fetchReferrerMappings() {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {merchantSiteId}
      dispatch(loadReferrerMappings(fetchParams)).fail(dispatch(reportError()))
    })
  }
}

export function fetchUnmappedUtms() {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {merchantSiteId}
      dispatch(loadUnmappedUtms(fetchParams)).fail(dispatch(reportError()))
    })
  }
}

export function fetchUtmMappings() {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {merchantSiteId}
      dispatch(loadUtmMappings(fetchParams)).fail(dispatch(reportError()))
    })
  }
}

export function fetchUnmappedImpressions(startDate, endDate, timezone) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const fetchParams = {
        merchantSiteId,
        startDate: formatDateWithTz(startDate, timezone),
        endDate: formatDateWithTz(endDate, timezone),
        timezone
      }
      dispatch(loadUnmappedImpressions(fetchParams)).fail(dispatch(reportError()))
    })
  }
}

export function mapUrlChannel({
  selectedText,
  selectedUrl,
  selectedOrigin,
  selectedPathname,
  selectedParameters,
  channelTypeId,
  channelGroupId,
  channelId
}) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      dispatch({
        [CALL_API]: {
          endpoint: `sites/${merchantSiteId}/urlMappings`,
          errorsHandled: true,
          method: 'POST',
          types: MAP_UNMAPPED_URL,
          body: {
            urlMapping: {
              url: selectedUrl || undefined,
              text: selectedText || undefined,
              origin: selectedOrigin || undefined,
              pathname: selectedPathname || undefined,
              params: selectedParameters || {}
            },
            channel: {
              dv_chtype: channelTypeId,
              dv_chgroup: channelGroupId,
              dv_channel: channelId
            }
          }
        }
      })
        .success(() => {
          dispatch(fetchUnmappedUrls())
        })
        .fail(dispatch(reportError()))
    })
  }
}

export function removeUrlMappings(urlMappings) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      dispatch({
        [CALL_API]: {
          endpoint: `sites/${merchantSiteId}/urlMappings`,
          errorsHandled: true,
          method: 'DELETE',
          types: DELETE_MAPPED_URL,
          body: {
            urlMappings
          }
        }
      })
        .success(() => {
          dispatch(fetchUrlMappings())
        })
        .fail(dispatch(reportError()))
    })
  }
}

export function removeReferrerMappings(regexMappings) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      dispatch({
        [CALL_API]: {
          endpoint: `sites/${merchantSiteId}/referrerMappings`,
          errorsHandled: true,
          method: 'DELETE',
          types: DELETE_MAPPED_REFERRER,
          body: {
            regexMappings
          }
        }
      })
        .success(() => {
          dispatch(fetchReferrerMappings())
        })
        .fail(dispatch(reportError()))
    })
  }
}

export function removeUtmMappings(utmMappings) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      dispatch({
        [CALL_API]: {
          endpoint: `sites/${merchantSiteId}/utmMappings`,
          errorsHandled: true,
          method: 'DELETE',
          types: DELETE_MAPPED_UTM,
          body: {
            utmMappings
          }
        }
      })
        .success(() => {
          dispatch(fetchUtmMappings())
        })
        .fail(dispatch(reportError()))
    })
  }
}


export function addMappingForCategory({category, mapping}, siteId) {
  return (dispatch, getState) => {
    const state = getState()
    const merchantSiteId = siteId || getCurrentSite(state).id
    return dispatch({
      [CALL_API]: {
        endpoint: `sites/${merchantSiteId}/categoryMappings`,
        errorsHandled: true,
        method: 'POST',
        types: ADD_CATEGORY_MAPPING,
        body: {category, mapping}
      }
    })
      .success(() => {
        const fetchParams = {merchantSiteId, category}
        dispatch(loadMappingsForCategory(fetchParams))
        dispatch(reset('catalogMappings'))
      })
      .fail(dispatch(reportError()))
  }
}

export function removeMappingsForCategory({mappingIds, category}) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const requests = mappingIds.map(mappingId => ({
        [CALL_API]: {
          endpoint: `sites/${merchantSiteId}/categoryMappings/${mappingId}`,
          errorsHandled: true,
          method: 'DELETE',
          types: REMOVE_CATEGORY_MAPPING
        }
      }))

      Call.all(dispatch(batchActions(requests)))
        .success(() => {
          const fetchParams = {merchantSiteId, category}
          dispatch(loadMappingsForCategory(fetchParams))
        })
        .fail(dispatch(reportError()))
    })
  }
}

export function mapReferrers({
  selectedReferer,
  channelTypeId,
  channelGroupId,
  channelId
}) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const referer = selectedReferer['referer']
        ? selectedReferer['referer']
        : []
      const mappings = referer.map(item => ({referer: item}))
      dispatch({
        [CALL_API]: {
          endpoint: `sites/${merchantSiteId}/referrerMappings`,
          errorsHandled: true,
          method: 'POST',
          types: MAP_UNMAPPED_REFERRER,
          body: {
            regexMappings: mappings,
            channel: {
              dv_chtype: channelTypeId,
              dv_chgroup: channelGroupId,
              dv_channel: channelId
            }
          }
        }
      })
        .success(() => {
          dispatch(fetchUnmappedReferrers())
        })
        .fail(dispatch(reportError()))
    })
  }
}

export function mapUtms({
  selectedParameters,
  channelGroupId,
  channelId
}) {
  return (dispatch, getState) => {
    getCurrentSitePlease(dispatch, getState).success(merchantSiteId => {
      const mappings = Object.keys(selectedParameters).reduce((acc, key) => {
        if (!selectedParameters[key]) return acc
        return {
          ...acc,
          [key]: selectedParameters[key]
        }
      }, {})
      dispatch({
        [CALL_API]: {
          endpoint: `sites/${merchantSiteId}/utmMappings`,
          errorsHandled: true,
          method: 'POST',
          types: MAP_UNMAPPED_UTM,
          body: {
            mapping: mappings,
            channel: {
              dv_chgroup: channelGroupId,
              dv_channel: channelId
            }
          }
        }
      })
        .success(() => {
          dispatch(fetchUnmappedUtms())
        })
        .fail(dispatch(reportError()))
    })
  }
}

export function exportUmmapImpressionData() {
  return (dispatch, getState) => {
    const data = getUnmappeImpressions(getState())
    const csvHeader = 'data:text/csv;charset=utf-8,'
    const csvFile = encodeURI(
      csvHeader +
        json2csv({
          data,
          fields: ['url', 'visits'],
          fieldNames: ['Url', 'Count']
        })
    )
    const link = document.createElement('a')
    link.setAttribute('href', csvFile)
    const timestamp = new Date().getTime()
    link.setAttribute('download', `impressions.${timestamp}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/settings/actions.js